import { useState, useEffect } from 'react';
import useOrgStore from '../store/zustand/useOrgStore';
import { KPIRulePartial } from '../_types/types.type';
import fetchKPIs from '../utils/fetchFunctions/fetchKPIs';

export default function useKPIs() {
  //  @ts-ignore
  const orgID = global.me.orgID;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const setKPIs = useOrgStore((state) => state.setKPIs);
  const KPIs: KPIRulePartial[] = useOrgStore((state) => state.KPIs);

  useEffect(() => {
    const fetchAndStoreKPIs = async () => {
      // Only fetch if we don't have data yet
      if (KPIs.length > 0) {
        return;
      }

      try {
        setIsLoading(true);
        const fetchedKPIs = await fetchKPIs();
        setKPIs(fetchedKPIs);
        setIsLoading(false);
      } catch (err) {
        setError(JSON.stringify(err));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndStoreKPIs();
  }, [orgID, KPIs.length]);

  return { isLoading, error, KPIs };
}
